export default __webpack_public_path__ + "static/media/logo-vertikal.d7962574.png";